import React from "react";
import { nanoid } from "nanoid";
import { colors } from "styles/colors";
import { StarSVG, StarContainer } from "./styled";

const Star = ({ rating, starId, hoverId, onHover, onClick }) => {
  const uniqId = nanoid();
  let gradientStop;
  if (hoverId) {
    gradientStop = starId <= hoverId ? "100%" : "0%";
  } else if (starId <= rating) {
    gradientStop = "100%";
  } else if (starId < rating + 1) {
    gradientStop = `${Math.round((rating - Math.floor(rating)) * 100)}%`;
  } else {
    gradientStop = "0%";
  }

  return (
    <StarContainer onMouseEnter={() => onHover(starId)} onMouseLeave={() => onHover(0)} onClick={() => onClick(starId)}>
      <StarSVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 31">
        <defs>
          <linearGradient id={`starfill${uniqId}`} x1="0" x2="100%" y1="0" y2="0">
            <stop offset={gradientStop} stopColor={colors.STAR_ORANGE}></stop>
            <stop offset={gradientStop} stopColor={colors.WHITE}></stop>
          </linearGradient>
        </defs>
        <path
          fill={`url(#starfill${uniqId})`}
          d="M15.5246 1.15427L15.5253 1.15556L19.9883 9.9922L20.1121 10.2373L20.3853 10.2643L28.9704 11.1153L28.9714 11.1155C29.1996 11.1376 29.3909 11.2875 29.4661 11.4956C29.5411 11.7031 29.4892 11.9356 29.3299 12.0933L29.3299 12.0933L22.2549 19.0969L22.0469 19.3028L22.1247 19.5851L24.7475 29.1005C24.7475 29.1007 24.7476 29.1009 24.7476 29.1011C24.8066 29.318 24.7325 29.5505 24.5542 29.6953C24.3751 29.8408 24.1251 29.8694 23.9163 29.7669C23.9161 29.7668 23.9159 29.7667 23.9157 29.7666L15.2219 25.4611L14.9998 25.3511L14.7779 25.4612L6.08331 29.7715C6.08326 29.7715 6.08322 29.7716 6.08317 29.7716C5.87482 29.8745 5.62478 29.8462 5.44591 29.7007C5.26783 29.5559 5.19429 29.3231 5.25423 29.1066L5.25444 29.1059L7.87528 19.5849L7.95293 19.3029L7.74508 19.097L0.670137 12.089L0.670014 12.0889C0.510717 11.9312 0.458782 11.6986 0.533794 11.4912C0.609034 11.2831 0.800365 11.1331 1.02848 11.111L1.02953 11.1109L9.61461 10.2599L9.88782 10.2328L10.0116 9.98776L14.4743 1.1519C14.4743 1.15176 14.4744 1.15161 14.4745 1.15146C14.5731 0.957572 14.7757 0.832496 15.0002 0.833009C15.2249 0.833523 15.427 0.959706 15.5246 1.15427Z"
        />
      </StarSVG>
    </StarContainer>
  );
};

export default Star;
